import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { GetListDataPageParams } from '../models/api/GetListDataPageParams';
import type { TableData } from '../models/TabTableTypes';

export interface GetCardsListDataInput {
  application: string;
  params: GetListDataPageParams;
  classId?: string;
  tabId?: string;
}

export interface GetCardsListDataOutput {
  length?: number;
  data?: TableData;
}

export function getCardsListData(input: GetCardsListDataInput): Promise<FetchResponse<GetCardsListDataOutput>> {
  return portalCustomAPI.fetch<GetCardsListDataInput, GetCardsListDataOutput>('getCardsListData', input);
}
